export {
  NonUKBankAccountReason,
  UKExemptSuppliesAnswer,
  UKPresenceType,
  UKVATRegistrationReason,
} from '@commenda/api/indirect-tax/registrations/formDataEnums';

export const REGISTRATION_CHANGED_MESSAGE =
  'This registration was updated elsewhere. Reload the page and try again.';
